import { Fetcher } from '../../Fetcher';

import type { StatsConfigType } from './types';

export interface FetchStatsConfigParams {
  url: string;
  ipAddress: string;
}

export const fetchStatsConfig = ({ url, ipAddress }: FetchStatsConfigParams): Promise<StatsConfigType> => {
  return Fetcher.fetch<StatsConfigType>(url + '/quality/video/' + ipAddress);
};
